import { ProductsWrapper } from "./style";
import Banner from "../../assets/images/banner.svg";
import BannerSecundary from "../../assets/images/banner-secundary.svg";
import { CarouselPrimary, CarouselSecundary } from "../../components/Carousel";

export function Products() {
  return (
    <ProductsWrapper>
      <img src={Banner} alt="banner" className="banner" />
      <p className="titleText">
        Dia do Consumidor <span>Ver mais produtos</span>
      </p>
      <CarouselPrimary />
      <img src={BannerSecundary} alt="" className="bannerSecundary" />
      <CarouselSecundary />
    </ProductsWrapper>
  );
}
